
import { DollarSign } from 'lucide-react';
import { ToolTip } from '../../../components/ToolTip';
const NetWorthBadge = ({ netWorth }) => {
  // Define tier thresholds and styling
  const getTierInfo = (worth) => {
    if (worth >= 1000000) {
      return {
        tier: 'Platinum',
        color: 'bg-indigo-100 text-indigo-800',
        hoverColor: 'hover:bg-indigo-200',
        icon: 'text-indigo-500',
        range: '$1,000,000+'
      };
    } else if (worth >= 500000) {
      return {
        tier: 'Gold',
        color: 'bg-yellow-100 text-yellow-800',
        hoverColor: 'hover:bg-yellow-200',
        icon: 'text-yellow-500',
        range: '$500,000 - $999,999'
      };
    } else {
      return {
        tier: 'Silver',
        color: 'bg-gray-100 text-gray-800',
        hoverColor: 'hover:bg-gray-200',
        icon: 'text-gray-500',
        range: 'Up to $499,999'
      };
    }
  };

  const { tier, color, hoverColor, icon, range } = getTierInfo(netWorth);

  return (
    <ToolTip content={`Net Worth Range: ${range}`}>
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color} ${hoverColor} cursor-help`}>
        <DollarSign className={`w-3 h-3 mr-1 ${icon}`} />
        {tier}
      </span>
    </ToolTip>
  );
};

export default NetWorthBadge;